import { render, staticRenderFns } from "./NwxSwitcher.vue?vue&type=template&id=1092588c&scoped=true"
import script from "./NwxSwitcher.vue?vue&type=script&lang=js"
export * from "./NwxSwitcher.vue?vue&type=script&lang=js"
import style0 from "./NwxSwitcher.vue?vue&type=style&index=0&id=1092588c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1092588c",
  null
  
)

export default component.exports